import {KorrelertSpørsmålModell, SpørsmålOppsett, Spørsmålstype} from 'felles-ng2/tjenester/ressurser/generertNg2HttpKlient';

/** Typen og oppsettet til et spørsmål, slik det sendes til eller mottas fra serveren */
export interface TypeOgOppsett {
    type: Spørsmålstype;
    oppsett: SpørsmålOppsett | null | undefined;
}

/**
 * Korrelasjon mellom et spørsmål og spørsmål i andre skjemaer, dvs spørsmål med samme korellasjonsId.
 *
 * Resultatene for korrelerte spørsmål sammenliknes på tvers av undersøkelser, og korrelerte spørsmål må derfor ha samme
 * type og oppsett (titler og verdier på svaralternativene, og maksimalt antall valg). Farger på alternativene kan avvike.
 * Avviker type eller oppsett må korrelasjonen brytes, ved at spørsmålet lagres uten korellasjonsId, ellers avvises
 * lagringen av serveren. Tilsvarer KorrelerteSpørsmål og Spørsmålsdefinisjon.harSammeTypeOgOppsettSom() i lederplan-tjenester.
 */
export class Korrelasjon {

    /** Korrelerte spørsmål med annen type eller annet oppsett enn angitt spørsmål, korrelasjonen må i så fall brytes */
    static avvikendeSpørsmål(spørsmål: TypeOgOppsett, korrelerte: KorrelertSpørsmålModell[]): KorrelertSpørsmålModell[] {
        const nøkkel = Korrelasjon.typeOgOppsettNøkkel(spørsmål);
        return korrelerte.filter(korrelert => Korrelasjon.typeOgOppsettNøkkel(korrelert.spoersmaal) !== nøkkel);
    }

    /** Sann dersom korrelasjonen med angitte korrelerte spørsmål må brytes, se {@link avvikendeSpørsmål} */
    static måBrytes(spørsmål: TypeOgOppsett, korrelerte: KorrelertSpørsmålModell[]): boolean {
        return Korrelasjon.avvikendeSpørsmål(spørsmål, korrelerte).length > 0;
    }

    // private hjelpemetoder

    /** Nøkkel som er lik for spørsmål med samme type og oppsett, farger på alternativene inngår ikke */
    private static typeOgOppsettNøkkel({type, oppsett}: TypeOgOppsett): string {
        const alternativer = (oppsett?.rangering ?? oppsett?.velgEnAvFlere ?? oppsett?.velgNoenAvFlere)?.alternativer ?? [];
        return JSON.stringify({
            type,
            rangering: oppsett?.rangering != null,
            velgEnAvFlere: oppsett?.velgEnAvFlere != null,
            velgNoenAvFlere: oppsett?.velgNoenAvFlere != null,
            alternativer: alternativer.map(alternativ => [alternativ.tittel.trim(), alternativ.verdi]),
            maksimaltAntallValg: oppsett?.velgNoenAvFlere?.maksimaltAntallValg ?? null
        });
    }
}
